export type RuntimeDistributionChannel = 'versioned-official-cdn';

export interface RuntimeReleaseProvenance {
  readonly provider: 'EmulatorJS';
  readonly version: string;
  readonly tag: string;
  readonly commitSha: string;
  readonly distribution: RuntimeDistributionChannel;
  readonly dataBaseUrl: string;
  readonly loaderUrl: string;
  readonly releaseArchiveUrl: string;
  readonly releaseArchiveSha256: string;
  readonly license: 'GPL-3.0';
}

export interface RuntimeCoreProvenance {
  readonly platform: 'GBA';
  readonly emulatorJsCore: 'mgba';
  readonly primaryAssetPath: 'cores/mgba-wasm.data';
  readonly threads: false;
  readonly biosRequired: false;
  readonly upstreamProject: 'mGBA';
  readonly upstreamSourceUrl: string;
  readonly upstreamLicense: 'MPL-2.0';
}

export interface EmulatorRuntimeManifest {
  readonly runtimeId: string;
  readonly release: RuntimeReleaseProvenance;
  readonly core: RuntimeCoreProvenance;
}

export const emulatorJsGbaRuntime: EmulatorRuntimeManifest = {
  runtimeId: 'emulatorjs-4.2.3-mgba-wasm',
  release: {
    provider: 'EmulatorJS',
    version: '4.2.3',
    tag: 'v4.2.3',
    commitSha: 'e150dc0491ae747028919fb82d6598954976ede6',
    distribution: 'versioned-official-cdn',
    dataBaseUrl: 'https://cdn.emulatorjs.org/4.2.3/data/',
    loaderUrl: 'https://cdn.emulatorjs.org/4.2.3/data/loader.js',
    releaseArchiveUrl: 'https://github.com/EmulatorJS/EmulatorJS/releases/download/v4.2.3/4.2.3.7z',
    releaseArchiveSha256: '07d451bc06fa3ad04ab30d9b94eb63ac34ad0babee52d60357b002bde8f3850b',
    license: 'GPL-3.0',
  },
  core: {
    platform: 'GBA',
    emulatorJsCore: 'mgba',
    primaryAssetPath: 'cores/mgba-wasm.data',
    threads: false,
    biosRequired: false,
    upstreamProject: 'mGBA',
    upstreamSourceUrl: 'https://github.com/EmulatorJS/mgba',
    upstreamLicense: 'MPL-2.0',
  },
};

const mutableRuntimeChannels = ['/stable/', '/latest/', '/nightly/'] as const;

export function isPinnedRuntimeUrl(url: string): boolean {
  return !mutableRuntimeChannels.some((channel) => url.includes(channel));
}
